import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowRight_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289L28.7071 15.2929C29.0976 15.6834 29.0976 16.3166 28.7071 16.7071L18.7071 26.7071C18.3166 27.0976 17.6834 27.0976 17.2929 26.7071C16.9024 26.3166 16.9024 25.6834 17.2929 25.2929L25.5858 17L4 17C3.44772 17 3 16.5523 3 16C3 15.4477 3.44772 15 4 15L25.5858 15L17.2929 6.70711C16.9024 6.31658 16.9024 5.68342 17.2929 5.29289Z"
            />
        </SvgStyled>
    );
};

export default ArrowRight_lg;
